import { IPoint } from "utils/types";

export enum POIType {
  city = 'city', // Міста, Села
  culture = 'culture', // Культура
  restaurant = 'restaurant', // Рестораны-бары-кафе
  organization = 'organization', // Організації
  religion = 'religion', // Церкви, Храми
  park = 'park', // Парки, Природа
  medicine = 'medicine', // Медицина, здоров'я
  station = 'station', // Вокзали, аеропорти
  shop = 'shop', // Магазини, ТЦ, Ринки
  metro = 'metro', // Метро
  education = 'education', // Навчальні заклади
  sport = 'sport', // Спорт, дозвілля
  hotel = 'hotel', // Готелі - Мотелі
  cemetery = 'cemetery', // Кладовище
  exit = 'exit', // Виїзд з міста
  transport = 'transport', // Транспорт
  housing_area = 'housing_area', // Масиви
  gas_station = 'gas_station', // АЗС, СТО, АГК
}

export enum AddressSelectionType {
  init = 'init',
  address = 'address',
  move = 'move',
  current = 'current',
  saved = 'saved',
}

export interface IStreet {
  id: number;
  name: string;
  comment?: string;
  new_name?: string;
}

export interface IStreetHouse {
  number: string;
  frontdoor?: string | null;
}

export interface IPOI {
  id: number;
  name: string;
  type?: POIType;
  comment?: string;
  new_name?: string;
}

export interface IRoutePoint {
  street?: IStreet;
  house?: IStreetHouse;
  poi?: IPOI;
  point?: IPoint;
  selection_type?: AddressSelectionType;
}

export interface IRoutePointComponent extends IRoutePoint {
  opacity?: boolean
}